import { createSlice } from '@reduxjs/toolkit'
import { getUtcNow, MillisecondsPerSecond } from 'utils/utils'

interface UsersState {
  token: string | null
  roles: string[]
  expiresAt: number | null
}

const initialState = {
  token: null,
  roles: [],
  expiresAt: null,
} satisfies UsersState as UsersState

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser(state, action) {
      state.token = action.payload.token
      state.roles = action.payload.roles
      state.expiresAt =
        getUtcNow().getTime() +
        action.payload.expires_in * MillisecondsPerSecond
    },
    removeUser(state) {
      state.token = null
      state.roles = []
      state.expiresAt = null
    },
  },
})

export const { setUser, removeUser } = userSlice.actions
export default userSlice.reducer
